import { useQuery } from "@apollo/client";
import { Card } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";
import useTagsVisibleInFilter from "src/app/Restricted/useTagsVisibleInFilter";
import { useAuth0 } from "src/contexts/auth0Provider";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import { ModalProvider } from "src/contexts/withModal";
import useUpdateTeamDetails from "src/hooks/useUpdateTeamDetails";
import TeamDetailsPanel from "src/pages/TeamPage/sub-components/TeamDetailsPanel";
import { getTeamDetailsQuery } from "src/queries/group.graphql";

import { useAIDashboardStore } from "../context/AIDashboardContext";

const CanvTeamDetails = ({ channel }) => {
  const store = useAIDashboardStore(channel);
  const teamId = store((state) => state.value?.id);
  const workspace = useWorkspace();
  const { user } = useAuth0();
  const tagsVisibleIn = useTagsVisibleInFilter();

  const { data, loading, error, refetch } = useQuery(getTeamDetailsQuery, {
    variables: { groupId: teamId },
    skip: !teamId,
  });

  const team = data?.getGroup;
  const groupTypes = workspace?.config?.groupTypes;

  const {
    handleUpdateTeamDetails,
    canUpdateGroupAttributes,
    editDetailsMode,
    setEditDetailsMode,
  } = useUpdateTeamDetails({ team, refetch });

  if (!teamId) {
    return (
      <Card style={{ padding: "16px", textAlign: "center", color: "#666" }}>
        Enter a Team ID to see details
      </Card>
    );
  }

  if (loading) {
    return (
      <Card style={{ padding: "16px", textAlign: "center" }}>
        Loading team details...
      </Card>
    );
  }

  if (error) {
    return (
      <Card style={{ padding: "16px", textAlign: "center", color: "#d32f2f" }}>
        Error loading team: {error.message}
      </Card>
    );
  }

  if (!team) {
    return (
      <Card style={{ padding: "16px", textAlign: "center", color: "#666" }}>
        Team not found
      </Card>
    );
  }

  return (
    (team && (
      <ModalProvider>
        <div style={{ height: "400px", overflow: "scroll" }}>
          <TeamDetailsPanel
            loading={loading}
            team={team}
            groupTypes={groupTypes}
            user={user}
            handleUpdateTeamDetails={handleUpdateTeamDetails}
            canUpdateGroupAttributes={canUpdateGroupAttributes}
            editDetailsMode={editDetailsMode}
            setEditDetailsMode={setEditDetailsMode}
            workspace={workspace}
            tagsVisibleIn={tagsVisibleIn}
          />
        </div>
      </ModalProvider>
    )) ||
    undefined
  );
};

CanvTeamDetails.propTypes = {
  channel: PropTypes.string.isRequired,
};

export default CanvTeamDetails;
